<template>
  <div class="sku-report poppins">
    <!-- ── Filters Section ──────────────────────────────────── -->
    <div class="sku-report__filters-card">
      <div class="d-flex align-items-center">
        <!-- <div class="d-flex align-items-center me-6">
          <v-icon size="20" color="#7e04b7" class="mr-2"
            >mdi-filter-variant</v-icon
          >
          <span class="sku-report__filters-title">Filters</span>
        </div> -->
        <v-row align="center" class="ma-0">
          <v-col cols="12" sm="6" md="4" lg="3">
            <label class="sku-report__label">Client</label>
            <v-select
              v-model="selectedClient"
              :items="clients"
              item-text="text"
              item-value="value"
              dense
              outlined
              placeholder="Select Client"
              hide-details
              class="sku-report__input"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <label class="sku-report__label">Date Range</label>
            <DateTimePickerWithBorder
              @on-submit="getDateRange"
              position="center"
            />
            <!-- <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  dense
                  outlined
                  readonly
                  hide-details
                  prepend-inner-icon="mdi-calendar-range"
                  placeholder="Select dates"
                  class="sku-report__input"
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="dateRange"
                range
                color="#7e04b7"
                no-title
                @change="onDateChange"
              />
            </v-menu> -->
          </v-col>
        </v-row>
      </div>
    </div>

    <!-- ── Summary Cards ────────────────────────────────────── -->
    <v-row class="sku-report__summary-row">
      <v-col v-for="(card, i) in summaryCards" :key="i" cols="12" sm="6" md="3">
        <div class="sku-report__summary-card">
          <div
            class="sku-report__summary-icon-wrap"
            :style="{ background: card.bg }"
          >
            <v-icon size="24" :color="card.color">{{ card.icon }}</v-icon>
          </div>
          <div class="sku-report__summary-info">
            <span class="sku-report__summary-label">{{ card.title }}</span>
            <span class="sku-report__summary-value">{{ card.value }}</span>
          </div>
          <div class="sku-report__summary-trend" :class="card.trendClass">
            <v-icon size="14" :color="card.trendColor">{{
              card.trendIcon
            }}</v-icon>
            {{ card.trend }}
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- ── Two-Column Section ───────────────────────────────── -->
    <v-row class="sku-report__columns-row">
      <!-- Left: Top 10 SKU Revenue -->
      <v-col cols="12" md="6">
        <div class="sku-report__panel">
          <div class="sku-report__panel-header">
            <v-icon size="24" color="#7e04b7" class="mr-2"
              >mdi-trophy-outline</v-icon
            >
            <span class="sku-report__panel-title">Top 10 SKU Revenue</span>
          </div>
          <div class="sku-report__panel-body">
            <div
              v-for="(item, idx) in topSkus"
              :key="idx"
              class="sku-report__sku-item"
            >
              <div class="sku-report__sku-rank">{{ idx + 1 }}</div>
              <div class="sku-report__sku-info">
                <div class="sku-report__sku-name-row">
                  <span class="sku-report__sku-name">{{ item.name }}</span>
                  <span class="sku-report__sku-value"
                    >${{ item.value.toLocaleString() }}</span
                  >
                </div>
                <v-progress-linear
                  :value="item.percent"
                  height="12"
                  rounded
                  :color="progressColor(idx)"
                  background-color="#f1f5f9"
                  class="sku-report__sku-bar"
                />
              </div>
            </div>
          </div>
        </div>
      </v-col>

      <!-- Right: Revenue Commitments -->
      <v-col cols="12" md="6">
        <div class="sku-report__panel">
          <div class="sku-report__panel-header">
            <v-icon size="24" color="#7e04b7" class="mr-2"
              >mdi-chart-pie</v-icon
            >
            <span class="sku-report__panel-title">Revenue Commitments</span>
          </div>
          <div class="sku-report__panel-body">
            <div
              v-for="(item, idx) in revenueCommitments"
              :key="idx"
              class="sku-report__commitment-item"
            >
              <div class="sku-report__commitment-left">
                <div
                  class="sku-report__commitment-dot"
                  :style="{ background: commitmentColor(idx) }"
                />
                <span class="sku-report__commitment-name">{{ item.name }}</span>
              </div>
              <div class="sku-report__commitment-right">
                <span class="sku-report__commitment-pct"
                  >{{ item.percent }}%</span
                >
                <v-progress-linear
                  :value="item.percent"
                  height="25"
                  rounded
                  :color="commitmentColor(idx)"
                  background-color="#f1f5f9"
                  class="sku-report__commitment-bar"
                />
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- ── SKU Revenue Details Table ────────────────────────── -->
    <div class="sku-report__card sku-report__table-card">
      <div class="sku-report__card-header">
        <span class="sku-report__card-title">
          <v-icon size="24" color="#7e04b7" class="mr-1"
            >mdi-table-large</v-icon
          >
          SKU Revenue Details
        </span>
        <v-spacer />
        <v-text-field
          v-model="tableSearch"
          dense
          outlined
          placeholder="Search SKU..."
          hide-details
          prepend-inner-icon="mdi-magnify"
          class="sku-report__table-search"
        />
      </div>
      <v-data-table
        :headers="tableHeaders"
        :items="tableData"
        :search="tableSearch"
        :items-per-page="10"
        disable-sort
        mobile-breakpoint="40"
        class="sku-report__data-table"
        :footer-props="{ 'items-per-page-options': [5, 10, 25] }"
      >
        <template v-slot:item.revenue="{ item }">
          <span class="font-weight-bold"
            >${{ item.revenue.toLocaleString() }}</span
          >
        </template>
        <template v-slot:item.avgPrice="{ item }">
          ${{ item.avgPrice.toFixed(2) }}
        </template>
        <template v-slot:item.contribution="{ item }">
          <v-chip
            small
            :color="getContributionColor(item.contribution)"
            text-color="white"
            class="sku-report__chip"
          >
            {{ item.contribution }}%
          </v-chip>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import DateTimePickerWithBorder from "@/own/components/DateTimePickerWithBorder.vue";
export default {
  name: "ReportRevenue",
  components: {
    DateTimePickerWithBorder,
  },
  data() {
    return {
      // ── Filters ──────────────────────────────────────────────
      selectedClient: null,
      clients: [
        { text: "All Clients", value: null },
        { text: "Acme Corp", value: "acme" },
        { text: "Globe Ltd", value: "globe" },
        { text: "Zenith Inc", value: "zenith" },
      ],
      dateMenu: false,
      // dateRange: [],
      filterData: {},
      dateRange: [this.today(), this.today()],
      tableSearch: "",

      // ── Summary Cards ────────────────────────────────────────
      summaryCards: [
        {
          title: "Total Revenue",
          value: "$128,430",
          icon: "mdi-cash-multiple",
          color: "#7e04b7",
          bg: "rgba(126,4,183,0.08)",
          trend: "+12.5%",
          trendIcon: "mdi-trending-up",
          trendColor: "#47be7d",
          trendClass: "sku-report__trend--up",
        },
        {
          title: "Total Orders",
          value: "3,842",
          icon: "mdi-cart-outline",
          color: "#5578eb",
          bg: "rgba(85,120,235,0.08)",
          trend: "+8.3%",
          trendIcon: "mdi-trending-up",
          trendColor: "#47be7d",
          trendClass: "sku-report__trend--up",
        },
        {
          title: "Avg Order Value",
          value: "$33.42",
          icon: "mdi-chart-line",
          color: "#47be7d",
          bg: "rgba(71,190,125,0.08)",
          trend: "-2.1%",
          trendIcon: "mdi-trending-down",
          trendColor: "#fd397a",
          trendClass: "sku-report__trend--down",
        },
        {
          title: "Total SKUs",
          value: "247",
          icon: "mdi-package-variant-closed",
          color: "#ff6b35",
          bg: "rgba(255,107,53,0.08)",
          trend: "+5 new",
          trendIcon: "mdi-plus",
          trendColor: "#47be7d",
          trendClass: "sku-report__trend--up",
        },
      ],

      // ── Top 10 SKU Revenue ───────────────────────────────────
      topSkus: [
        { name: "SKU-A1001", value: 18500, percent: 100 },
        { name: "SKU-B2032", value: 15200, percent: 82 },
        { name: "SKU-C3044", value: 12800, percent: 69 },
        { name: "SKU-D4015", value: 10400, percent: 56 },
        { name: "SKU-E5078", value: 9200, percent: 50 },
        { name: "SKU-F6023", value: 7800, percent: 42 },
        { name: "SKU-G7091", value: 6500, percent: 35 },
        { name: "SKU-H8064", value: 5100, percent: 28 },
        { name: "SKU-I9017", value: 3900, percent: 21 },
        { name: "SKU-J1056", value: 2400, percent: 13 },
      ],

      // ── Revenue Commitments ──────────────────────────────────
      revenueCommitments: [
        { name: "SKU-A1001", percent: 18.5 },
        { name: "SKU-B2032", percent: 15.2 },
        { name: "SKU-C3044", percent: 12.8 },
        { name: "SKU-D4015", percent: 10.4 },
        { name: "SKU-E5078", percent: 9.2 },
        { name: "SKU-F6023", percent: 7.8 },
        { name: "SKU-G7091", percent: 6.5 },
        { name: "SKU-H8064", percent: 5.1 },
        { name: "SKU-I9017", percent: 3.9 },
        { name: "SKU-J1056", percent: 2.4 },
      ],

      // ── Table Headers ────────────────────────────────────────
      tableHeaders: [
        { text: "SKU", value: "sku" },
        { text: "Product Name", value: "product" },
        { text: "Revenue", value: "revenue" },
        { text: "Orders", value: "orders" },
        { text: "Avg Price", value: "avgPrice" },
        { text: "Contribution", value: "contribution" },
      ],

      // ── Table Data ───────────────────────────────────────────
      tableData: [
        {
          sku: "SKU-10482",
          product: "Wireless Charger",
          revenue: 18420,
          orders: 614,
          avgPrice: 29.99,
          contribution: 18.4,
        },
        {
          sku: "SKU-20391",
          product: "Bluetooth Speaker",
          revenue: 15830,
          orders: 452,
          avgPrice: 34.99,
          contribution: 15.8,
        },
        {
          sku: "SKU-30125",
          product: "USB-C Hub",
          revenue: 13290,
          orders: 380,
          avgPrice: 34.97,
          contribution: 13.3,
        },
        {
          sku: "SKU-40287",
          product: "Phone Case Pro",
          revenue: 11750,
          orders: 587,
          avgPrice: 19.99,
          contribution: 11.8,
        },
        {
          sku: "SKU-50934",
          product: "Screen Protector",
          revenue: 9640,
          orders: 482,
          avgPrice: 19.99,
          contribution: 9.6,
        },
        {
          sku: "SKU-60178",
          product: "Laptop Stand",
          revenue: 8920,
          orders: 223,
          avgPrice: 39.99,
          contribution: 8.9,
        },
        {
          sku: "SKU-70543",
          product: "LED Desk Lamp",
          revenue: 7580,
          orders: 253,
          avgPrice: 29.96,
          contribution: 7.6,
        },
        {
          sku: "SKU-80219",
          product: "Webcam HD",
          revenue: 6340,
          orders: 127,
          avgPrice: 49.92,
          contribution: 6.3,
        },
        {
          sku: "SKU-90367",
          product: "Keyboard Mech",
          revenue: 5120,
          orders: 128,
          avgPrice: 40.0,
          contribution: 5.1,
        },
        {
          sku: "SKU-11045",
          product: "Mouse Pad XL",
          revenue: 4210,
          orders: 421,
          avgPrice: 9.99,
          contribution: 3.2,
        },
        {
          sku: "SKU-12093",
          product: "HDMI Cable 2m",
          revenue: 3870,
          orders: 387,
          avgPrice: 9.99,
          contribution: 3.1,
        },
        {
          sku: "SKU-13401",
          product: "Power Bank 10K",
          revenue: 3520,
          orders: 176,
          avgPrice: 19.99,
          contribution: 2.8,
        },
        {
          sku: "SKU-14782",
          product: "Car Mount",
          revenue: 2960,
          orders: 148,
          avgPrice: 19.99,
          contribution: 2.4,
        },
        {
          sku: "SKU-15890",
          product: "Earbuds Basic",
          revenue: 2450,
          orders: 245,
          avgPrice: 9.99,
          contribution: 1.9,
        },
        {
          sku: "SKU-16023",
          product: "USB Flash 64GB",
          revenue: 1890,
          orders: 189,
          avgPrice: 9.99,
          contribution: 1.5,
        },
      ],
    };
  },

  computed: {
    dateRangeText() {
      if (!this.dateRange || this.dateRange.length === 0) return "";
      if (this.dateRange.length === 1) return this.dateRange[0];
      return `${this.dateRange[0]}  —  ${this.dateRange[1]}`;
    },
  },

  methods: {
    dateFormatter(date, charForJoin = "-") {
      return [
        date.getFullYear(),
        date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : `0${date.getMonth() + 1}`,
        date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`,
      ].join(charForJoin);
    },
    today() {
      const d = new Date();
      return this.dateFormatter(d);
    },
    getToday() {
      const date = new Date();
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    formatDate(date) {
      if (!date) return null;
      const d = new Date(date);
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      const day = d.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    dataOfFilters() {
      const today = this.getToday();
      const formattedStart = this.formatDate(this.dateRange[0]);
      const formattedEnd = this.formatDate(this.dateRange[1]);
      const dateRangeType =
        formattedStart === today && formattedEnd === today ? "today" : "custom";

      const filterData = {
        date_range_type: dateRangeType,
        date_range: this.dateRange,
        ...this.filterData,
      };
      return filterData;
    },
    updateDataOfCharts(data) {
      this.filterData = { ...this.filterData, ...data };
      // call api request
      // this.updateDashboardData(this.dataOfFilters(), this.filterData);
    },
    getDateRange(val) {
      this.dateRange = val;
      this.updateDataOfCharts(this.filterData);
    },
    getContributionColor(pct) {
      if (pct >= 15) return "#7e04b7";
      if (pct >= 10) return "#5578eb";
      if (pct >= 5) return "#47be7d";
      return "#8993a4";
    },
    onDateChange() {
      if (this.dateRange.length === 2) {
        this.dateMenu = false;
      }
    },

    progressColor(idx) {
      const colors = [
        "#7e04b7",
        "#9333ea",
        "#a855f7",
        "#b47de8",
        "#5578eb",
        "#6895f7",
        "#47be7d",
        "#6dd5a1",
        "#ff6b35",
        "#ffb822",
      ];
      return colors[idx % colors.length];
    },

    commitmentColor(idx) {
      const colors = [
        "#7e04b7",
        "#9333ea",
        "#a855f7",
        "#b47de8",
        "#5578eb",
        "#6895f7",
        "#47be7d",
        "#6dd5a1",
        "#ff6b35",
        "#ffb822",
      ];
      return colors[idx % colors.length];
    },

    contributionChipColor(val) {
      if (val >= 15) return "#7e04b7";
      if (val >= 10) return "#5578eb";
      if (val >= 5) return "#47be7d";
      return "#94a3b8";
    },
  },
};
</script>

<style lang="scss" scoped>
/* ── Variables ──────────────────────────────────────────────── */
$primary: #7e04b7;
$border: rgba(0, 0, 0, 0.06);
$radius: 14px;
$radius-sm: 10px;
$shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 4px 16px rgba(0, 0, 0, 0.04);
$font: "Poppins", sans-serif;
$title-font-size: 17px;
$value-font-size: 15px;

/* ── Page wrapper ───────────────────────────────────────────── */
.sku-report {
  padding: 8px 32px 40px;
  font-family: $font;

  @media (max-width: 960px) {
    padding: 8px 16px 32px;
  }
  @media (max-width: 600px) {
    padding: 8px 12px 24px;
  }
}
.sku-report__card {
  background: #ffffff;
  border-radius: $radius;
  box-shadow: $shadow;
  border: 1px solid $border;
  overflow: hidden;
}

.sku-report__card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  border-bottom: 1px solid $border;
  flex-wrap: wrap;
  gap: 10px;
}

.sku-report__card-title {
  font-family: $font;
  font-size: $title-font-size;
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
}

.sku-report__card-body {
  padding: 16px 20px;

  @media (max-width: 600px) {
    padding: 12px 14px;
  }
}
/* ── Table Section ──────────────────────────────────────────── */
.sku-report__table-card {
  margin-bottom: 40px;
}

.sku-report__table-search {
  max-width: 220px;

  ::v-deep .v-input__slot {
    border-radius: $radius-sm !important;
    min-height: 36px !important;
  }

  @media (max-width: 600px) {
    max-width: 100%;
    width: 100%;
  }
}

.sku-report__data-table {
  font-family: $font;

  ::v-deep {
    .v-data-table-header th {
      font-family: $font !important;
      font-size: 12px !important;
      font-weight: 600 !important;
      color: #64748b !important;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      background: #f8fafc;
      border-bottom: 1px solid $border !important;
      white-space: nowrap;
    }

    tbody tr {
      transition: background 0.15s ease;

      &:hover {
        background: rgba($primary, 0.02) !important;
      }

      td {
        font-family: $font !important;
        font-size: 13px;
        color: #334155;
        border-bottom: 1px solid rgba(0, 0, 0, 0.04) !important;
        padding: 12px 16px;
      }
    }

    .v-data-footer {
      font-family: $font;
      font-size: 12px;
      border-top: 1px solid $border;
    }
  }
}

.sku-report__chip {
  font-family: $font;
  font-size: 11px !important;
  font-weight: 600;
  letter-spacing: 0.3px;
}
/* ── Filters Card ───────────────────────────────────────────── */
.sku-report__filters-card {
  background: #fff;
  border-radius: $radius;
  box-shadow: $shadow;
  border: 1px solid $border;
  padding: 20px 24px 24px;
  margin-bottom: 24px;

  @media (max-width: 600px) {
    padding: 16px 14px 18px;
  }
}

.sku-report__filters-title {
  font-family: $font;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.sku-report__label {
  display: block;
  font-family: $font;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.sku-report__input ::v-deep .v-input__slot {
  border-radius: $radius-sm !important;
  min-height: 40px !important;
}

/* ── Summary Cards ──────────────────────────────────────────── */
.sku-report__summary-row {
  margin-bottom: 0px;
}

.sku-report__summary-card {
  background: #fff;
  border-radius: $radius;
  box-shadow: $shadow;
  border: 1px solid $border;
  padding: 20px;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  transition: box-shadow 0.25s ease, transform 0.25s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
  }
}

.sku-report__summary-icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sku-report__summary-info {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.sku-report__summary-label {
  font-family: $font;
  font-size: 12px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 4px;
}

.sku-report__summary-value {
  font-family: $font;
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
}

.sku-report__summary-trend {
  position: absolute;
  top: 14px;
  right: 16px;
  font-family: $font;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px 8px;
  border-radius: 6px;
}

.sku-report__trend--up {
  color: #47be7d;
  background: rgba(71, 190, 125, 0.1);
}

.sku-report__trend--down {
  color: #fd397a;
  background: rgba(253, 57, 122, 0.1);
}

/* ── Panels (shared for both columns) ───────────────────────── */
.sku-report__columns-row {
  margin-bottom: 24px;
  margin-top: 0px;
}

.sku-report__panel {
  background: #fff;
  border-radius: $radius;
  box-shadow: $shadow;
  border: 1px solid $border;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.sku-report__panel-header {
  display: flex;
  align-items: center;
  padding: 18px 20px;
  border-bottom: 1px solid $border;
}

.sku-report__panel-title {
  font-family: $font;
  font-size: $title-font-size;
  font-weight: 600;
  color: #1e293b;
}

.sku-report__panel-body {
  padding: 16px 20px 20px;
  flex: 1;

  @media (max-width: 600px) {
    padding: 12px 14px 16px;
  }
}

/* ── Top SKU Revenue List ───────────────────────────────────── */
.sku-report__sku-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  &:first-child {
    padding-top: 0;
  }
}

.sku-report__sku-rank {
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background: rgba($primary, 0.08);
  color: $primary;
  font-family: $font;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sku-report__sku-info {
  flex: 1;
  min-width: 0;
}

.sku-report__sku-name-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.sku-report__sku-name {
  font-family: $font;
  font-size: $value-font-size;
  font-weight: 600;
  color: #1e293b;
}

.sku-report__sku-value {
  font-family: $font;
  font-size: $value-font-size;
  font-weight: 700;
  color: #1e293b;
}

.sku-report__sku-bar {
  border-radius: 4px;
}

/* ── Revenue Commitments List ───────────────────────────────── */
.sku-report__commitment-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  &:first-child {
    padding-top: 0;
  }
}

.sku-report__commitment-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.sku-report__commitment-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.sku-report__commitment-name {
  font-family: $font;
  font-size: $value-font-size;
  font-weight: 600;
  color: #1e293b;
}

.sku-report__commitment-right {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 140px;
}

.sku-report__commitment-pct {
  font-family: $font;
  font-size: $value-font-size;
  font-weight: 700;
  color: #1e293b;
  min-width: 45px;
  text-align: right;
}

.sku-report__commitment-bar {
  flex: 1;
  min-width: 60px;
}

/* ── Table Card ─────────────────────────────────────────────── */
.sku-report__table-card {
  background: #fff;
  border-radius: $radius;
  box-shadow: $shadow;
  border: 1px solid $border;
  overflow: hidden;
}

.sku-report__data-table {
  font-family: $font;

  ::v-deep {
    thead th {
      font-family: $font !important;
      font-size: 12px !important;
      font-weight: 600 !important;
      color: #64748b !important;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      background: #f8fafc !important;
      border-bottom: 1px solid $border !important;
      white-space: nowrap;
    }

    tbody td {
      font-family: $font !important;
      font-size: $value-font-size !important;
      color: #334155 !important;
      border-bottom: 1px solid rgba(0, 0, 0, 0.04) !important;
      padding-top: 12px !important;
      padding-bottom: 12px !important;
    }

    tbody tr:hover {
      background: rgba($primary, 0.02) !important;
    }

    .v-data-footer {
      font-family: $font;
      font-size: $value-font-size;
      border-top: 1px solid $border;
    }
  }
}

.sku-report__chip {
  font-family: $font;
  font-size: 11px !important;
  font-weight: 600;
  letter-spacing: 0.3px;
}
</style>
